import { applyMiddleware, createStore } from "redux";
import { createStateSyncMiddleware, initMessageListener } from "redux-state-sync";

const initialState = {
  sidebarShow: "responsive",
  login: false,
  recruit_access:false,
  storageNoti: false,
  queued_exports: []
};

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case "set":
      return { ...state, ...rest };
    case "login":
      return { ...state, ...rest };
    case  "set-exports":
      return { ...state, queued_exports: rest.queued_exports };
    default:
      return state;
  }
};

const config = {
  blacklist: ["set-exports"],
};

const store = createStore(changeState, applyMiddleware(createStateSyncMiddleware(config)));

initMessageListener(store);

export default store;
